import { render, staticRenderFns } from "./ColumnTransactionStatusFiserv.vue?vue&type=template&id=27d48ff9&scoped=true"
import script from "./ColumnTransactionStatusFiserv.vue?vue&type=script&lang=js"
export * from "./ColumnTransactionStatusFiserv.vue?vue&type=script&lang=js"
import style0 from "./ColumnTransactionStatusFiserv.vue?vue&type=style&index=0&id=27d48ff9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d48ff9",
  null
  
)

export default component.exports